









































































import Vue from "vue";
import { currentUser, myClassesDetail } from "@/api/my";
import { datetimeFormat, emptyValue, enumI18nFormat } from "@/utils/lang";
import _ from "lodash";
import MyClassDetailOverview from "@/views/my/MyClassDetailOverview.vue";
import BuildPlanGroupInfo from "@/utils/app-utils";
import { createNamespacedHelpers } from "vuex";

const { mapGetters, mapActions } = createNamespacedHelpers("config");

export default Vue.extend({
    name: "MyClassesDetail",
    components: { MyClassDetailOverview },
    props: {
        classId: Number
    },
    data() {
        return {
            activeTab: "basicInfo",
            classDetail: null,
            classImage: require("@/assets/class.png"),
            studentName: ""
        };
    },
    async mounted() {
        this.getDetail();
        this.getStudentName();
        await this.getOrgConfig();
    },
    methods: {
        ...mapActions(["getOrgConfig"]),
        getDetail(): void {
            myClassesDetail(this.classId).then(resp => {
                if (resp.data) {
                    this.classDetail = resp.data.data;
                }
            });
        },
        getStudentName(): void {
            if (this.$store.getters["login/loggedIn"]) {
                currentUser().then(resp => {
                    if (resp.data) {
                        this.studentName = resp.data.data.name;
                    }
                });
            }
        }
    },
    computed: {
        ...mapGetters(["orgConfig"]),
        planPath(): any {
            const planId = _.get(this.klassSummery, "enrollmentPlanGroupStatistics.enrollmentPlans[0].id");
            if (this.showToPlanDetailLink && planId) {
                return `/plan/${planId}`;
            }
            return "";
        },
        showToPlanDetailLink(): boolean {
            return !this.planMerged;
        },
        planMerged(): boolean {
            return this.klassSummery.enrollmentPlanGroupStatistics.merged;
        },
        klassSummery(): any {
            const planGroupInfo = BuildPlanGroupInfo(
                _.get(this.classDetail, "enrollmentPlanGroupStatistics.enrollmentPlans", [])
            );
            const enrollmentPlanGroupStatistics = _.get(this.classDetail, "enrollmentPlanGroupStatistics");
            return {
                klassName: _.get(this.classDetail, "klassName"),
                klassCode: _.get(this.classDetail, "code"),
                startAt: _.get(this.classDetail, "startAt"),
                endAt: _.get(this.classDetail, "endAt"),
                enrollmentPlanGroupStatistics: enrollmentPlanGroupStatistics,
                studentCount: _.get(this.classDetail, "studentCount", "0") + this.$t("my.class.studentCountUnit"),
                planName: emptyValue(_.get(enrollmentPlanGroupStatistics, "name")),
                programNames: planGroupInfo.programName,
                classificationNames: planGroupInfo.classificationName,
                occupationNames: planGroupInfo.occupationName,
                occupationLevels: planGroupInfo.occupationLevel,
                certificateTypes: planGroupInfo.certificateType,
                classLocation: emptyValue(_.get(this.classDetail, "classLocation")),
                teachingDirectorNames: this.teachingDirectorNames,
                klassStatus: _.get(this.classDetail, "klassStatus", "")
            };
        },
        classOverview(): any {
            return {
                klassName: this.klassSummery.klassName,
                status: this.klassSummery.klassStatus,
                startAt: this.startAt,
                endAt: this.endAt
            };
        },
        startAt(): any {
            if (!_.get(this.classDetail, "startAt")) {
                return this.$t("common.noContent");
            }
            return datetimeFormat(_.get(this.klassSummery, "startAt"));
        },
        endAt(): any {
            if (!_.get(this.classDetail, "endAt")) {
                return this.$t("common.noContent");
            }
            return datetimeFormat(_.get(this.klassSummery, "endAt"));
        },
        occupationInfo(): any {
            return _.get(this.classDetail, "program.occupationInfo", {});
        },
        teachingDirectorNames(): any {
            return _.isEmpty(_.get(this.classDetail, "managers"))
                ? this.$t("common.noContent")
                : _.join(_.map(_.get(this.classDetail, "managers"), "name"));
        },
        klassCourses(): any {
            return _.get(this.classDetail, "klassCourses", []);
        },
        trainingOccupationEnabled(): boolean {
            if (Object.keys(this.orgConfig).length == 0) {
                return true;
            }
            return !!this.orgConfig["trainingOccupationEnabled"];
        }
    }
});
